<template>
  <div>
    <vxe-grid
      size="small"
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.replenishmentStatus === 'N'
              ? 'primary'
              : row.replenishmentStatus === 'D'
              ? 'danger'
              : row.replenishmentStatus === 'P'
              ? 'warning'
              : row.replenishmentStatus === 'Y'
              ? 'success'
              : row.replenishmentStatus === 'S'
              ? 'logistics'
              : 'info'
          "
        >
          {{ row.v_replenishmentStatus }}
        </el-tag>
      </template>
      <template v-slot:skuSalesChannel="{ row }">
        <el-tag
          v-if="row.v_skuSalesChannel"
          size="mini"
          :type="
            row.skuSalesChannel === 'F'
              ? 'success'
              : row.skuSalesChannel === 'V'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_skuSalesChannel }}
        </el-tag>
      </template>
      <template v-slot:replenishmentDateRange="{ row }">
        <div>{{ `${row.beginDate} - ${row.endDate}` }}</div>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { amzReplenishmentCode, amzReplenishmentNo } = data
      if (!menuType || !amzReplenishmentCode) return

      switch (menuType) {
        case 'detail':
        case 'reply':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { amzReplenishmentCode },
            query: { amzReplenishmentNo },
          })
          break
        case 'back':
          this.back(data)
          break
        case 'export':
          this.$emit('export', data, opt.data)
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    async back({ amzReplenishmentCode, isForced = 'N' }) {
      let confirm
      if ('N' == isForced) {
        confirm = await this.$confirm(
          this.$l('tips_replyBack') || '是否要回退补货需求？',
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
          }
        )
          .then(() => true)
          .catch(() => false)
        if (!confirm) return
      }
      this.loadingOpen()
      const res = await this.$api
        .ecomAmzReplenishmentReplyBackApi({ amzReplenishmentCode, isForced })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, msg } = res
      if (200 === status) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_operate_ok'),
          type: 'success',
        })
        this.$emit('reload')
      }

      if (203 === status) {
        confirm = await this.$confirm(
          this.$l('tips_replyBackForced') || msg,
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
          }
        )
          .then(() => true)
          .catch(() => false)
        if (!confirm) return
        this.back({ amzReplenishmentCode, isForced: 'Y' })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-tag--logistics {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
